/* @flow */

import "./BrandbarPopoverNameComponent.scss";

import React from "react";

import { BusinessAccountResponse } from "../../../../datatypes/businessaccounts/BusinessAccount";
import { ProfileLink } from "../businessaccounts/ProfileLink";
import { LogoutLink } from "../businessaccounts/LogoutLink";
import { History } from "history";

type Props = {
    businessAccountData: BusinessAccountResponse | undefined | null;
    name: React.ReactNode;
    businessName: string | undefined | null;
    history?: History;
};

export class BrandbarPopoverNameComponent extends React.Component<Props> {
    isBusinessAccount() {
        return !!this.props.businessAccountData;
    }

    renderNameAndProfileLinks() {
        return (
            <React.Fragment>
                <h4>{this.props.name}</h4>
                <ProfileLink data={this.props.businessAccountData} history={this.props.history} /> –{" "}
                <LogoutLink data={this.props.businessAccountData} />
            </React.Fragment>
        );
    }

    renderNameMetroX() {
        return (
            <React.Fragment>
                <div className="popover-person-name">{this.props.name}</div>
                <h4>{this.props.businessName}</h4>
            </React.Fragment>
        );
    }

    render() {
        // TODO the image url part is missing for businessaccount, but it is unclear where in the data that would be
        // stored. currently 'personalProfileUrl' is in the accountData in the Alex response, and not on the person level.
        // For the accounts we are already displaying the abbreviation
        return (
            <div className="dropdown-menu-item dropdown-menu-item-account">
                {this.isBusinessAccount() && (
                    <div className="m-media">
                        <div className="m-media-visual">
                            <div className="m-profilePicture m-profilePicture-isMedium">
                                <div className="m-profilePicture-button">
                                    <div className="m-profilePicture-abbreviation" />
                                    <div
                                        className="m-profilePicture-image"
                                        style={{
                                            backgroundImage:
                                                "url('/ordercapture/uidispatcher/static/app/assets/images/dummy_profile_picture.png')"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="m-media-content">
                            <div className="m-address">{this.renderNameAndProfileLinks()}</div>
                        </div>
                    </div>
                )}
                {!this.isBusinessAccount() && this.renderNameMetroX()}
            </div>
        );
    }
}
